import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'panel-ribbon',
	template: `<aside><ng-content></ng-content></aside>`
})
export class PanelRibbonComponent implements OnInit {
	ngOnInit(): void {}
}
